import React from 'react';
import { ISelection } from '../../../../../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import {
  ISelectedAnalysAnalys,
  ISelectedAnalysCodePrivilege,
  ISelectedAnalys,
} from '../../../../../EkonomiskAnalysPage';

interface IEkonomiskAnalysSelectContext {
  selectInputRef: React.RefObject<HTMLInputElement | null>;
  selectAnalys: (
    analys: ISelectedAnalysAnalys,
    codePrivilege: ISelectedAnalysCodePrivilege,
    unsavedAnalys?: boolean,
    callback?: () => void
  ) => void;
  deselectAnalys: (ignoreStartAnalys?: boolean) => void;
  fullAnalysList: ISelection[];
  selectedAnalys: ISelectedAnalys | null;
}

export const EkonomiskAnalysSelectContext: React.Context<IEkonomiskAnalysSelectContext> =
  React.createContext<IEkonomiskAnalysSelectContext>({
    selectInputRef: React.createRef<HTMLInputElement>(),
    selectAnalys: () => {},
    deselectAnalys: () => {},
    fullAnalysList: [],
    selectedAnalys: null,
  });

export const EkonomiskAnalysSelectProvider =
  EkonomiskAnalysSelectContext.Provider;
export const EkonomiskAnalysSelectConsumer =
  EkonomiskAnalysSelectContext.Consumer;
